var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.linkClass},[_c('p',{staticClass:"pointer",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('on:link-click')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }